module.exports = __webpack_public_path__ + "fonts/gt-walsheim-medium-web.woff";